var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, Button, InputOtp, Loader, Typography, getTestId, tokens, useBreakpoint } from '@airtel/air-design-system';
import { useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import { ButtonWidget } from '../button-widget';
import { CalloutWidget } from '../callout-widget';
import { getOtpWidgetStyles } from './OtpWidgetStyles';
import { readOtpWebview, stopOtpListenerWebview, isMobileApp } from '@airtel-lego/native-app-bridge';
export var OtpWidgetComponent = props => {
  var _props$rtn = props.rtn,
    rtn = _props$rtn === void 0 ? '' : _props$rtn,
    _props$state = props.state,
    state = _props$state === void 0 ? 'none' : _props$state,
    _props$title = props.title,
    title = _props$title === void 0 ? 'OTP verification' : _props$title,
    _props$subTitle = props.subTitle,
    subTitle = _props$subTitle === void 0 ? 'sent successfully to ' : _props$subTitle,
    subTitleBold = props.subTitleBold,
    _props$infoTextTop = props.infoTextTop,
    infoTextTop = _props$infoTextTop === void 0 ? 'enter OTP' : _props$infoTextTop,
    _props$loadingTitle = props.loadingTitle,
    loadingTitle = _props$loadingTitle === void 0 ? 'verifying your number' : _props$loadingTitle,
    _props$changeNumberCt = props.changeNumberCta,
    changeNumberCta = _props$changeNumberCt === void 0 ? '' : _props$changeNumberCt,
    _props$infoTextBottom = props.infoTextBottom,
    infoTextBottom = _props$infoTextBottom === void 0 ? '' : _props$infoTextBottom,
    _props$isValidating = props.isValidating,
    isValidating = _props$isValidating === void 0 ? false : _props$isValidating,
    _props$autocomplete = props.autocomplete,
    autocomplete = _props$autocomplete === void 0 ? false : _props$autocomplete,
    _props$resendTimerCou = props.resendTimerCount,
    resendTimerCount = _props$resendTimerCou === void 0 ? 30 : _props$resendTimerCou,
    _props$numberOfInputs = props.numberOfInputs,
    numberOfInputs = _props$numberOfInputs === void 0 ? 4 : _props$numberOfInputs,
    _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? '' : _props$defaultValue,
    _props$startCounter = props.startCounter,
    startCounter = _props$startCounter === void 0 ? false : _props$startCounter,
    secondaryCtaProps = props.secondaryCtaProps,
    _props$primaryCtaProp = props.primaryCtaProps,
    primaryCtaProps = _props$primaryCtaProp === void 0 ? {} : _props$primaryCtaProp,
    onSuccess = props.onSuccess,
    onChangeCtaPress = props.onChangeCtaPress,
    onUserAction = props.onUserAction,
    onOtpBoxPress = props.onOtpBoxPress,
    onInputFilled = props.onInputFilled,
    _props$otpInputContai = props.otpInputContainerStyle,
    otpInputContainerStyle = _props$otpInputContai === void 0 ? {} : _props$otpInputContai,
    _props$secondaryCtaTi = props.secondaryCtaTitlePostfix,
    secondaryCtaTitlePostfix = _props$secondaryCtaTi === void 0 ? 'in' : _props$secondaryCtaTi,
    _props$showCalloutWid = props.showCalloutWidget,
    showCalloutWidget = _props$showCalloutWid === void 0 ? false : _props$showCalloutWid,
    _props$calloutWidgetP = props.calloutWidgetProps,
    calloutWidgetProps = _props$calloutWidgetP === void 0 ? {} : _props$calloutWidgetP,
    rtnOnChangeCta = props.rtnOnChangeCta,
    testID = props.testID,
    _props$enableiOSOTPSu = props.enableiOSOTPSuggestionFix,
    enableiOSOTPSuggestionFix = _props$enableiOSOTPSu === void 0 ? false : _props$enableiOSOTPSu,
    _props$titleStyles = props.titleStyles,
    titleStyles = _props$titleStyles === void 0 ? {} : _props$titleStyles,
    restProps = __rest(props, ["rtn", "state", "title", "subTitle", "subTitleBold", "infoTextTop", "loadingTitle", "changeNumberCta", "infoTextBottom", "isValidating", "autocomplete", "resendTimerCount", "numberOfInputs", "defaultValue", "startCounter", "secondaryCtaProps", "primaryCtaProps", "onSuccess", "onChangeCtaPress", "onUserAction", "onOtpBoxPress", "onInputFilled", "otpInputContainerStyle", "secondaryCtaTitlePostfix", "showCalloutWidget", "calloutWidgetProps", "rtnOnChangeCta", "testID", "enableiOSOTPSuggestionFix", "titleStyles"]);
  var _ref = secondaryCtaProps || {
      title: 'resend',
      counterSuffix: 's',
      buttonType: 'tertiary'
    },
    _ref$title = _ref.title,
    secondaryCtaTitle = _ref$title === void 0 ? 'resend' : _ref$title,
    counterSuffix = _ref.counterSuffix,
    secondaryCtaButtonType = _ref.buttonType;
  var ref = useRef();
  var otpWidgetStyles = getOtpWidgetStyles();
  var _useState = useState(state),
    otpState = _useState[0],
    setOtpState = _useState[1];
  var _useState2 = useState(resendTimerCount),
    timer = _useState2[0],
    setTimer = _useState2[1];
  var _useState3 = useState(null),
    timerId = _useState3[0],
    setTimerId = _useState3[1];
  var _useState4 = useState(secondaryCtaTitle),
    resendBtnText = _useState4[0],
    setResendBtnText = _useState4[1];
  var _useState5 = useState(false),
    isInputFilled = _useState5[0],
    setIsInputFilled = _useState5[1];
  var _useState6 = useState(''),
    otpValue = _useState6[0],
    setOtpValue = _useState6[1];
  var _useState7 = useState(infoTextBottom),
    _infoTextBottom = _useState7[0],
    setInfoTextBottom = _useState7[1];
  var _useState8 = useState(false),
    isOtpAutoFilled = _useState8[0],
    setIsOtpAutoFilled = _useState8[1];
  var userActionExtraData = Object.assign({
    rtn,
    otp: otpValue
  }, props);
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  useEffect(() => {
    var ac = new AbortController();
    if ('OTPCredential' in window) {
      var credential = navigator.credentials;
      credential.get({
        otp: {
          transport: ['sms']
        },
        signal: ac.signal
      }).then(otp => {
        var _a, _b;
        var otpValue = (_a = otp === null || otp === void 0 ? void 0 : otp.code) === null || _a === void 0 ? void 0 : _a.toString();
        setOtpValue(otpValue);
        (primaryCtaProps === null || primaryCtaProps === void 0 ? void 0 : primaryCtaProps.onPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign(Object.assign({}, primaryCtaProps.onPress), {
          actions: [...((onInputFilled === null || onInputFilled === void 0 ? void 0 : onInputFilled.actions) || []), ...(((_b = primaryCtaProps === null || primaryCtaProps === void 0 ? void 0 : primaryCtaProps.onPress) === null || _b === void 0 ? void 0 : _b.actions) || [])]
        }), Object.assign(Object.assign({}, userActionExtraData), {
          otp: otpValue
        })));
      }).catch(() => {});
    }
    if (isMobileApp()) {
      readOtpWebview().then(otp => {
        var otpValue = otp === null || otp === void 0 ? void 0 : otp.toString();
        setOtpValue(otpValue);
        setIsOtpAutoFilled(true);
      }).catch(() => {
        stopOtpListenerWebview();
      });
    }
    return () => {
      ac.abort();
      stopOtpListenerWebview();
    };
  }, []);
  useEffect(() => {
    setResendBtnText(secondaryCtaTitle);
  }, [secondaryCtaTitle]);
  useEffect(() => {
    if (state && !isValidating) {
      setOtpState(state);
    }
  }, [state, isValidating]);
  useEffect(() => {
    if (infoTextBottom && !isValidating) {
      setInfoTextBottom(infoTextBottom);
    }
  }, [infoTextBottom, isValidating]);
  var titleFontType = isSmallScreen ? 'body-single-line-lg-bold' : 'body-single-line-xl-bold';
  var subTitleFontType = isSmallScreen ? 'body-para-sm' : 'body-para-md';
  var subTitleBoldFontType = isSmallScreen ? 'body-para-sm-bold' : 'body-para-md-bold';
  var loaderLabelFontType = isSmallScreen ? 'body-single-line-md-bold' : 'body-single-line-xl-bold';
  useEffect(() => {
    if (startCounter) {
      startTimer();
    }
    setOtpState('none');
  }, [startCounter]);
  useEffect(() => {
    if (timer < 0) {
      clearInterval(timerId);
    }
  }, [timer, timerId]);
  useEffect(() => {
    setOtpState(state);
    setIsInputFilled(false);
    if (state == 'success') {
      onSuccess && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(onSuccess, userActionExtraData));
    }
  }, [state]);
  useEffect(() => {
    if (defaultValue) inputChangeHandler(defaultValue);
  }, [defaultValue]);
  var startTimer = () => {
    setTimerId(setInterval(() => {
      var tempResendText = secondaryCtaTitle;
      setTimer(timer => {
        var updatedTimer = timer - 1;
        if (updatedTimer < 0) {
          setResendBtnText(tempResendText);
        } else {
          tempResendText = secondaryCtaTitle + " " + secondaryCtaTitlePostfix + " " + updatedTimer + counterSuffix;
          setResendBtnText(tempResendText);
        }
        return updatedTimer;
      });
    }, 1000));
  };
  var resetTimer = () => {
    clearInterval(timerId);
    setTimer(resendTimerCount);
    if (startCounter) {
      startTimer();
    }
  };
  var primaryBtnProps = Object.assign(Object.assign(Object.assign(Object.assign({
    title: 'proceed',
    buttonType: 'primary'
  }, primaryCtaProps), {
    disabled: !isInputFilled
  }), getTestId(testID, 'rightCta')), {
    onPress: () => {
      (primaryCtaProps === null || primaryCtaProps === void 0 ? void 0 : primaryCtaProps.onPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(primaryCtaProps.onPress, userActionExtraData));
    },
    style: isInputFilled ? primaryCtaProps === null || primaryCtaProps === void 0 ? void 0 : primaryCtaProps.style : {},
    size: isSmallScreen ? 'md' : 'lg'
  });
  var secondaryBtnProps = Object.assign(Object.assign(Object.assign(Object.assign({}, secondaryCtaProps), {
    buttonType: secondaryCtaButtonType,
    title: resendBtnText,
    disabled: timer >= 0 || (secondaryCtaProps === null || secondaryCtaProps === void 0 ? void 0 : secondaryCtaProps.disabled),
    size: isSmallScreen ? 'md' : 'lg',
    onPress: () => {
      var _a;
      (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.clear();
      (secondaryCtaProps === null || secondaryCtaProps === void 0 ? void 0 : secondaryCtaProps.onPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(secondaryCtaProps.onPress, userActionExtraData));
      resetTimer();
    }
  }), getTestId(testID, 'leftCta')), {
    style: Object.assign(Object.assign({}, otpWidgetStyles.secondaryButton), secondaryCtaProps === null || secondaryCtaProps === void 0 ? void 0 : secondaryCtaProps.style)
  });
  var inputChangeHandler = data => {
    var _a;
    setOtpValue(data);
    setOtpState('none');
    setInfoTextBottom('');
    if (numberOfInputs == ((_a = data === null || data === void 0 ? void 0 : data.toString()) === null || _a === void 0 ? void 0 : _a.length)) {
      setIsInputFilled(true);
      onInputFilled && onUserAction(onInputFilled, Object.assign(Object.assign({}, userActionExtraData), {
        otp: data,
        isOtpAutoFilled: isOtpAutoFilled
      }));
      if (autocomplete) {
        primaryBtnProps.onPress();
      }
    } else {
      setIsInputFilled(false);
    }
  };
  var otpBoxPressHandler = index => {
    onOtpBoxPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onOtpBoxPress), Object.assign(Object.assign({}, userActionExtraData), {
      index
    })));
  };
  var subtitleText = subTitle + " " + rtn;
  if (rtnOnChangeCta && subTitle) subtitleText = subTitle;
  return _jsx(View, Object.assign({}, getTestId(testID), restProps, {
    children: isValidating ? _jsxs(View, Object.assign({
      style: otpWidgetStyles.loaderContainer
    }, {
      children: [_jsx(Loader, {
        size: isSmallScreen ? 'xl' : 'xxl'
      }), _jsx(Typography, Object.assign({
        text: loadingTitle,
        type: loaderLabelFontType,
        style: otpWidgetStyles.loaderLabel
      }, getTestId(testID, 'loadingTitle')))]
    })) : _jsxs(View, {
      children: [_jsx(View, Object.assign({
        style: otpWidgetStyles.titleContainer
      }, {
        children: !!title && _jsx(Typography, Object.assign({
          style: Object.assign(Object.assign({}, otpWidgetStyles.textCenter), titleStyles),
          type: titleFontType,
          text: title
        }, getTestId(testID, 'title')))
      })), _jsx(View, Object.assign({
        style: otpWidgetStyles.rtnContainer
      }, {
        children: !!subTitle && _jsx(Typography, Object.assign({
          style: [otpWidgetStyles.textCenter],
          color: BLACK_700,
          type: subTitleFontType,
          text: subtitleText
        }, getTestId(testID, 'subTitle')))
      })), !!subTitleBold && _jsx(View, Object.assign({
        style: otpWidgetStyles.rtnContainer
      }, {
        children: !!subTitleBold && _jsx(Typography, Object.assign({
          style: otpWidgetStyles.textCenter,
          color: BLACK_700,
          type: subTitleBoldFontType,
          text: subTitleBold
        }, getTestId(testID, 'subTitleBold')))
      })), !!changeNumberCta && _jsx(View, Object.assign({
        style: [otpWidgetStyles.rtnContainer, rtnOnChangeCta && {
          marginBottom: tokens.spacing.SPACING_0
        }]
      }, {
        children: _jsx(Button, Object.assign({}, restProps === null || restProps === void 0 ? void 0 : restProps.changeNumberCtaAccessibilityProps, {
          style: otpWidgetStyles.changeButton,
          title: rtnOnChangeCta ? rtn : changeNumberCta,
          buttonType: "tertiary",
          size: isSmallScreen ? 'md' : 'lg',
          version: "fixed-padding",
          iconPosition: "right",
          iconName: 'EditIcon',
          isCapitalize: false,
          onPress: () => onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(onChangeCtaPress, userActionExtraData)
        }, getTestId(testID, 'changeNumberCta')))
      })), _jsx(View, Object.assign({
        style: [otpWidgetStyles.otpInputContainer, otpInputContainerStyle]
      }, {
        children: _jsx(InputOtp, Object.assign({
          ref: ref,
          numberOfInputs: numberOfInputs,
          label: infoTextTop,
          hintText: _infoTextBottom,
          useStateHintColor: true,
          state: otpState,
          onOtpChange: inputChangeHandler,
          onOtpBoxPress: otpBoxPressHandler,
          defaultValue: otpValue,
          enableiOSOTPSuggestionFix: enableiOSOTPSuggestionFix
        }, getTestId(testID, 'otpValue')))
      })), showCalloutWidget && _jsx(CalloutWidget, Object.assign({}, Object.assign(Object.assign({}, calloutWidgetProps), {
        titleProps: Object.assign(Object.assign({}, calloutWidgetProps.titleProps), {
          numberOfLines: 1
        }),
        descriptionProps: Object.assign(Object.assign({}, calloutWidgetProps.descriptionProps), {
          numberOfLines: 2
        })
      }), {
        style: otpWidgetStyles.calloutWidgetStyles
      })), _jsx(ButtonWidget, {
        direction: "column",
        leftCta: secondaryBtnProps,
        rightCta: primaryBtnProps,
        style: otpWidgetStyles.btnWidgetStyles
      })]
    })
  }));
};
OtpWidgetComponent.genericRendererKey = 'AirOtpWidget';